import React from "react";

import classNames from "classnames";
import moment from "moment";
import { renderToStaticMarkup } from "react-dom/server";

import { isCalendarClusterEvent } from "../../../utils/typePredicate";
import ContentTooltipItem from "../timeline/ContentTooltipItem";

import type { JSX } from "react";
import type { EventProps } from "react-big-calendar";

import type { CalendarEvent } from "./Calendar";

const MIN_EVENT_DURATION_TO_SHOW_TITLE = 12 * 60 * 1000;

function CalendarWeekEvent({ event }: EventProps<CalendarEvent>): JSX.Element {
  const isCluster = isCalendarClusterEvent(event);

  const duration = moment(event.end).diff(moment(event.start));

  const showTitle = duration > MIN_EVENT_DURATION_TO_SHOW_TITLE;

  const tooltipItem = (
    <ContentTooltipItem
      duration={event.resource.duration}
      endTime={moment(event.resource.endTime)}
      image={event.resource.picture}
      startTime={moment(event.resource.startTime)}
      title={event.resource.label}
    />
  );

  const containerClassNames = classNames(
    "flex size-full items-center justify-center",
    {
      "cursor-pointer": !isCluster,
    },
  );

  return (
    <div
      className={containerClassNames}
      data-tooltip-html={renderToStaticMarkup(tooltipItem)}
      data-tooltip-id="calendar-date-cell"
      data-tooltip-place="left"
    >
      {showTitle ? (
        <div className="truncate p-[0.15625rem]">{event.resource.label}</div>
      ) : null}
    </div>
  );
}

export default CalendarWeekEvent;
